import { useNavigate } from "react-router-dom";
import {
  DataTable,
  // DataTablePageEvent,
  // DataTableSortEvent,
} from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
// import { parseQueryString, toQueryString } from "../../../common/utils";
import { useJourneyTypes } from "../../../api/queries/enum/useJourneyTypes";
import { JourneyType } from "../../../api/types/enum";

export default function ContextList() {
  const navigate = useNavigate();
  // const limit = 20;
  // const queryParams = parseQueryString(useLocation().search);

  // const [offset, setOffset] = useState(0);
  // const [total, setTotal] = useState(0);
  // const [sortField, setSortField] = useState(queryParams.sortField);
  // const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);

  // const onPage = ({ first }: DataTablePageEvent) => setOffset(first);
  // const onSort = (event: DataTableSortEvent) => {
  //   setSortField(event.sortField);
  //   setSortOrder(event.sortOrder);
  // };

  const { data: journeyTypesResponse, isLoading } = useJourneyTypes();

  const tName = (row: JourneyType) => row.name;

  // useEffect(() => {
  //   const queryParamsStr = toQueryString({
  //     limit: 20,
  //     offset,
  //     sortField,
  //     sortOrder,
  //   });
  //   navigate({ search: queryParamsStr });
  // }, [offset, navigate, sortField, sortOrder]);

  // useEffect(() => {
  //   if (journeyTypesResponse) {
  //     setTotal(journeyTypesResponse.data.total_count);
  //   }
  // }, [journeyTypesResponse]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Contexts</h1>

        <Button
          onClick={() => navigate("/admin/contexts/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <DataTable
        emptyMessage={"No records"}
        // paginator={true}
        // lazy={true}
        // rows={20}
        // first={offset}
        // totalRecords={total}
        loading={isLoading}
        // sortField={sortField}
        // sortOrder={sortOrder}
        // onPage={onPage}
        // onSort={onSort}
        value={journeyTypesResponse?.data.results || []}
        className="p-datatable-sm p-datatable-pointer"
        stripedRows={true}
      >
        <Column header={"Name"} body={tName} />
      </DataTable>
    </div>
  );
}
